import { ImportRow } from '../types/users.types';

/** Debe coincidir EXACTAMENTE con CSV_HEADERS del backend (user-csv.parser.ts). */
export const TEMPLATE_HEADERS = [
  'name',
  'email',
  'role',
  'branchOffice',
  'chainId',
  'password',
  'branchOfficeName',
  'userCode',
  'employeeNumber',
];

const EJEMPLOS = [
  'Vendedor Regina,vendedor.vzregina@colectivomoda.com,vendedor,1,VAZ,,,,',
  'Bodeguero Regina,bodeguero.vzregina@colectivomoda.com,bodeguero,1,VAZ,,,,',
];

/** Escapa un valor para CSV (comillas dobles y comas). */
function esc(value: string): string {
  if (/[",\n]/.test(value)) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function buildTemplateCsv(): string {
  return [TEMPLATE_HEADERS.join(','), ...EJEMPLOS].join('\n');
}

export function buildReportCsv(rows: ImportRow[]): string {
  const header = 'linea,email,estado,motivo';
  const body = rows.map((r) =>
    [String(r.linea), esc(r.email), r.estado, esc(r.motivo ?? '')].join(','),
  );
  return [header, ...body].join('\n');
}

export function downloadCsv(filename: string, content: string): void {
  // BOM para que Excel abra bien los acentos.
  const blob = new Blob(['﻿' + content], {
    type: 'text/csv;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
